const REPLAY_BASE_PATH = '/replay';

/** Hub route — top unviewed and recently replayed lists. */
export function replayHubPath(): string {
  return REPLAY_BASE_PATH;
}

/**
 * Game trainer route, optionally opening at a half move (1-based, matching the
 * trainer UI). Omits the query when opening at the first half move.
 */
export function replayGamePath(gameId: string, halfMove?: number): string {
  const params = new URLSearchParams();
  if (halfMove != null && halfMove > 1) {
    params.set('ply', String(halfMove));
  }
  const query = params.toString();
  return `${REPLAY_BASE_PATH}/${encodeURIComponent(gameId)}${query ? `?${query}` : ''}`;
}

export function parseReplayGameSearch(search: string): {
  /** 1-based half move from `?ply=`; null when absent (defaults to 1). */
  halfMove: number | null;
  /** Legacy `?startFen=` URLs; normalized on load to `?ply=`. */
  legacyStartFen: string | null;
} {
  const params = new URLSearchParams(search);
  const plyParam = params.get('ply');
  const startFen = params.get('startFen');
  const parsedPly = plyParam != null ? Number.parseInt(plyParam, 10) : Number.NaN;

  return {
    halfMove:
      plyParam != null && Number.isFinite(parsedPly) && parsedPly >= 1
        ? parsedPly
        : null,
    legacyStartFen: startFen ? decodeURIComponent(startFen) : null,
  };
}

export function isReplayPath(pathname: string): boolean {
  return (
    pathname === REPLAY_BASE_PATH || pathname.startsWith(`${REPLAY_BASE_PATH}/`)
  );
}
